import axios from '@/libs/api.request'
import config from '@/config'

const privateCloudBaseUrl = config.basePrivateCloudUrl + '/cloud/api/v1/'

export const getPrivateCloudKeyPair = (params) => {
  return axios.request({
    url: privateCloudBaseUrl + 'keypair/',
    needPrivateCloudProjectHeader: true,
    params: params,
    method: 'get'
  })
}

export const getPrivateCloudAllKeyPair = () => {
  return axios.request({
    url: privateCloudBaseUrl + 'all_keypair_list/',
    needPrivateCloudProjectHeader: true,
    method: 'get'
  })
}

export const detailPrivateCloudKeyPair = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'keypair/' + id + '/',
    needPrivateCloudProjectHeader: true,
    method: 'get'
  })
}

export const changePrivateCloudKeyPair = (data) => {
  return axios.request({
    url: privateCloudBaseUrl + 'keypair/',
    needPrivateCloudProjectHeader: true,
    data: data,
    method: 'post'
  })
}

export const deletePrivateCloudKeyPair = (id) => {
  return axios.request({
    url: privateCloudBaseUrl + 'keypair/' + id + '/',
    needPrivateCloudProjectHeader: true,
    method: 'delete'
  })
}
